






















































import { Vue, Component } from 'vue-property-decorator'
import { Route } from 'vue-router'
import Logo from '@/components/layout/Logo.vue'
import Banner from '@/components/layout/Banner.vue'
import Footer from '@/components/layout/Footer.vue'
import Notice from '@/components/exam/Notice.vue'
import { getCaptcha, login, loginByStorage } from '@/services/session/auth'
import { QUERY_FROM } from '@/router/guards/auth'
import { ConfigStore } from '@/store/config'
import { alert } from '@/utils/notification'
import { getKey } from '@/utils/key'
import { ElForm } from 'element-ui/types/form'

@Component({
  components: { Logo, Banner, Footer, Notice }
})
export default class Login extends Vue {
  getKey = getKey
  form = {
    username: '',
    password: '',
    code: '',
    persistence: false
  }
  loading = false
  captcha = ''
  rules = {
    username: [
      { required: true, message: '请输入身份证号码', trigger: 'blur' }
    ],
    password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
    code: { required: true, message: '请输入验证码', trigger: 'blur' }
  }

  get notice() {
    return ConfigStore.configs.find(a => a.key === 'notice')?.value ?? []
  }

  async beforeRouteEnter(to: Route, from: Route, next: () => void) {
    const re = await loginByStorage(to.query[QUERY_FROM] as string)
    if (!re) next()
  }

  async created() {
    this.handleRefreshCaptcha()
  }

  async handleRefreshCaptcha() {
    this.form.code = ''
    this.captcha = ''
    this.captcha = await getCaptcha()
  }

  async handleLogin() {
    try {
      const form = this.$refs.form as ElForm
      await form.validate()
    } catch (e) {
      return
    }

    try {
      this.loading = true
      const result = await login(this.form)
      if (!result) this.handleRefreshCaptcha()
    } catch (e) {
      alert('登录失败', e)
    } finally {
      this.loading = false
    }
  }

  handleRegister() {
    this.$router.push(`register`)
  }

  handleIdentify() {
    this.$router.push(`identify`)
  }
}
